export default {
    ALREADY_REGISTERED: 'Campaign already registered!',
    IS_IN_DRAFTS: 'This campaign is already registered on the platform but is currently in drafts.',
    NOT_FOUND: 'Campaign not found',
    INVALID_URL: 'Invalid url!',
    NOT_KICKSTARTER_URL: 'Only kickstarter.com links are allowed'
}